import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import {
  fetchMyPayments,
  summarize,
  formatINR,
  formatDate
} from '../../../features/payments/memberPayments'

const DISMISS_KEY = 'bl-payment-alert-dismissed'

// Banner telling a member they have an outstanding additional-area payment
// (figures as on the date of the latest audited statement).
const PaymentDueAlert = ({ showLink = true }) => {
  const [state, setState] = useState(null) // { asOn, outstanding }
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem(DISMISS_KEY) === '1'
    } catch (e) {
      return false
    }
  })

  useEffect(() => {
    let alive = true
    fetchMyPayments()
      .then(res => {
        if (alive) setState({ asOn: res.asOn, outstanding: summarize(res.entries).outstanding })
      })
      .catch(() => {}) // no data / admin — no alert
    return () => { alive = false }
  }, [])

  if (!state || state.outstanding < 1 || (dismissed && showLink)) return null

  const dismiss = () => {
    setDismissed(true)
    try { sessionStorage.setItem(DISMISS_KEY, '1') } catch (e) {}
  }

  return (
    <div className="bl-alert bl-alert--danger" role="alert">
      <div className="bl-alert__icon" aria-hidden="true">
        <ion-icon name="alert-circle-outline"></ion-icon>
      </div>
      <div className="bl-alert__body">
        <strong>Payment outstanding: {formatINR(state.outstanding)}</strong>
        <span>
          Your additional area / flat contribution has a balance
          {state.asOn ? ` as on ${formatDate(state.asOn)}` : ''}. Upload your receipt once paid.
        </span>
        {showLink && (
          <Link to="/payment-details" className="bl-alert__link">
            View payment details
          </Link>
        )}
      </div>
      {showLink && (
        <button type="button" className="btn btn-icon btn-sm" onClick={dismiss} aria-label="Dismiss payment reminder">
          <ion-icon name="close-outline" aria-hidden="true"></ion-icon>
        </button>
      )}
    </div>
  )
}

export default PaymentDueAlert
